module.exports = __webpack_public_path__ + "img/ico_paixu_hangqing.40539573.png";